module.exports = __webpack_public_path__ + "static/media/time.9e5d3067.svg";